import { add as snackbarAdd } from "actions/snackbars";
import { EventTypes } from "redux-segment";
import { formatMessage } from "lib/globalize-util";
import { LEGACY_REQUEST_ACCESS_COMPLETED, LEGACY_REQUEST_ACCESS_REQUEST } from "constants/action-types";
import { OTS_REQUEST_ACCESS } from "constants/analytics";
import { requestAccess } from "queries/legacy-retailers";
import { requestAsync } from "lib/api";

export const makeAccessRequest = (brandId, data) => {
    return (dispatch) => {
        dispatch({
            type: LEGACY_REQUEST_ACCESS_REQUEST,
        });
        return dispatch(requestAsync(requestAccess(brandId, data))).then((response) => {
            if (response.status >= 200 && response.status < 400) {
                const requestedConnection = response.body;
                return dispatch({
                    meta: {
                        analytics: {
                            eventPayload: {
                                event: OTS_REQUEST_ACCESS,
                                options: {
                                    groupId: brandId,
                                },
                                properties: {
                                    ...data,
                                    brand: brandId,
                                },
                            },
                            eventType: EventTypes.track,
                        },
                    },
                    payload: { requestedConnection },
                    type: LEGACY_REQUEST_ACCESS_COMPLETED,
                });
            } else {
                const message = response.body.message || "";
                dispatch(
                    snackbarAdd({
                        message:
                            message || formatMessage("There was an error submitting your request. Please try again."),
                    })
                );

                // auth errors
                if (response.status === 401 || response.status === 403) {
                    window.location.reload();
                }

                return dispatch({
                    error: true,
                    payload: new Error(message || "There was an error submitting your request."),
                    type: LEGACY_REQUEST_ACCESS_COMPLETED,
                });
            }
        });
    };
};
